// extracted by mini-css-extract-plugin
export var container = "Processes-module--container--384vv";
export var squareWrap = "Processes-module--squareWrap--35qwW";
export var none = "Processes-module--none--2uup3";